<template>
    <div class='txtStylePicker'>
        <div class='left' :class='{"active" : txtStyleType === 0}' @click='updateTxtStyleType(0)'>
            <div class='txtStyle-icon'>
                <div class='max'></div>
                <div class='min'></div>
                <div class='max'></div>
                <div class='min'></div>
            </div>
        </div>
        <div class='center' :class='{"active" : txtStyleType === 1}' @click='updateTxtStyleType(1)'>
            <div class='txtStyle-icon' style='align-items: center'>
                <div class='max'></div>
                <div class='min'></div>
                <div class='max'></div>
                <div class='min'></div>
            </div>
        </div>
        <div class='right' :class='{"active" : txtStyleType === 2}' @click='updateTxtStyleType(2)'>
            <div class='txtStyle-icon' style='align-items: flex-end'>
                <div class='max'></div>
                <div class='min'></div>
                <div class='max'></div>
                <div class='min'></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        txtStyleType:{
            type: Number,
            default: null
        }
    },
    data() {
        return {
        }
    },
    methods:{
        updateTxtStyleType(e){
            this.$emit('updateTxtStyleType',e)
        },
    }
};
</script>

<style lang='scss' scoped>
.txtStylePicker{
    width: 141px;
    height: 35px;
    margin: 10px 0;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    overflow: hidden;
    display: flex;
    .txtStyle-icon{
        width: 19px;
        height: 19px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .max{
            width: 20px;
            height: 2px;
            background-color: #000;
        }
        .min{
            width: 14px;
            height: 2px;
            background-color: #000;
        }
    }
    .left{
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

    }
    .center{
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-left: 1px solid #dcdfe6;
        border-right: 1px solid #dcdfe6;

    }
    .right{
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

    }
    .active{
        background-color: #409eff;
        div>div{
            background-color: #fff !important;
        }
    }
}
</style>